// Exact strategy -> pattern mapping. Mirror of
// supabase/functions/_shared/strategyRegistry.ts — keep both identical.
export const STRATEGY_PATTERN_MAP: Record<string, string> = {
  "Motivation Asymmetry": "Motivation Asymmetry Detector",
  "Underdog Situational": "Underdog Situational Advantage",
  "Controlled Chaos Leagues": "Controlled Chaos Leagues",
  "High-Odds Repeatability": "High-Odds Repeatability Filter",
  "Correct Score Trigger": "Correct Score Trigger Engine",
  "Extended Combos": "Extended Combo Markets",
  "Combo Market Builder": "High-Odds Combo Builder",
  "Defensive Collapse Index": "Defensive Collapse Index",
  "Goal Distribution Skew": "Goal Distribution Skew Model",
  "Reputation Bias": "Reputation Bias Exploitation",
  "GG/NG 2+ Specialist": "BTTS Specialists",
  "Both Teams Active": "BTTS Specialists",
  "Draw Specialist": "Draw Specialists",
  "Counter-Attack Efficiency": "Counter Attack Special",
  "Corner Patterns": "Corner Feast",
  "Corners Over 8.5": "Corner Feast",
  "Cards Over 2.5": "Card Magnet",
  "Late Goal Tendency": "Late Drama",
  "Late Goal Specialist": "Late Drama",
  "First Goal Before 30": "First Half Goal Rush",
  "Multi-Goal Burst": "Goal Fest",
  "Derby Factor": "Derby Upset",
  "Odds Movement": "Odds Compression Detection",
  "Steam Move Detection": "Odds Compression Detection",
  "Win-to-Nil Predictor": "Low Block Victory",
  "Away Consistency": "Away Day Specialist",
  "Second Half Surge": "Late Drama",
  "Scoreline Signature": "Scoreline Signature",
  "Half Imbalance": "Half Imbalance Detector",
  "Schedule Fatigue": "Schedule Fatigue Exploitation",
  "Fouls & Cards": "Card Magnet",
  "Formation Vulnerability": "Formation Mismatch Goals",
};

/** Strategies (from the pick's triggered list) that map exactly to a pattern. */
export function strategiesForPattern(patternName: string, triggered: string[]): string[] {
  return triggered.filter((s) => s === patternName || STRATEGY_PATTERN_MAP[s] === patternName);
}

/** Read the engine's real counts; fall back to the active-strategy total. */
export function strategyCounts(
  signals: { triggered_strategies?: string[]; triggered_count?: number; total_strategies_checked?: number } | null | undefined,
  fallbackTotal: number,
): { triggered: number; total: number } {
  const triggered = signals?.triggered_count ?? signals?.triggered_strategies?.length ?? 0;
  const total = signals?.total_strategies_checked && signals.total_strategies_checked >= triggered
    ? signals.total_strategies_checked
    : Math.max(fallbackTotal, triggered);
  return { triggered, total };
}
